/**
 * The idle lock (./kunciDiam) wired to the tab, on every screen of an unlocked session: the
 * shell and the sign-in screens it can reach (a step the API asked for mid-session, the offer
 * after a recovery, the first download), not only behind the guard. Input of any kind counts;
 * a check every 30 seconds and whenever the tab is shown again. It waits while anything on
 * screen is not saved (app/store/belumDisimpan): a form with unsaved changes, and a figure a
 * field-by-field screen could not save yet. Held back that way past the ten minutes, it tells
 * the screen once per idle period (./diamTertahan): a shown password is masked again and an
 * initial password emptied, the work stays. ./app installs it once for the tab's life; the
 * DOM tests install it, drive `periksa` and take it down again.
 */
import { adaBelumDisimpan } from '../app/store/belumDisimpan'
import { useSesi } from '../app/store/sesi'
import { umumkanDiamTertahan } from './diamTertahan'
import { buatKunciDiam } from './kunciDiam'

export const PERIKSA_DIAM_MS = 30_000

export interface KunciDiamTab {
  /** Locks now if the session is open, idle ten minutes and nothing is unsaved. */
  periksa(): void
  /** Takes the listeners, the timer and the subscription down. */
  lepas(): void
}

export function pasangKunciDiam(kunciSesi: () => void): KunciDiamTab {
  const kunci = buatKunciDiam({
    now: () => Date.now(),
    aktif: () => useSesi.getState().status === 'aktif',
    kotor: adaBelumDisimpan,
    kunci: kunciSesi,
    tertahan: umumkanDiamTertahan,
  })
  const events: (keyof WindowEventMap)[] = ['pointerdown', 'keydown', 'wheel', 'touchstart']
  for (const name of events) window.addEventListener(name, kunci.sentuh, { passive: true })
  const terlihat = () => {
    if (document.visibilityState === 'visible') kunci.periksa()
  }
  document.addEventListener('visibilitychange', terlihat)
  const jam = window.setInterval(kunci.periksa, PERIKSA_DIAM_MS)
  const berhenti = useSesi.subscribe((state, previous) => {
    if (state.status !== previous.status) kunci.sesiBerubah(state.status === 'aktif')
  })
  return {
    periksa: kunci.periksa,
    lepas: () => {
      for (const name of events) window.removeEventListener(name, kunci.sentuh)
      document.removeEventListener('visibilitychange', terlihat)
      window.clearInterval(jam)
      berhenti()
    },
  }
}
